let mixins = {}
try {
  // noinspection NpmUsedModulesInstalled
  mixins = require('marketing/playcards/_mixins/playcard-list').default
} catch (e) {
  //
}

export default mixins
